// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"139":"oss2026docs","407":"panel","884":"admin","962":"home"}[chunkId] || chunkId) + "." + {"139":"e2db96e4","407":"2c421d83","884":"093cf5dc","928":"af19c30a","962":"01049e8e"}[chunkId] + ".css";
};